import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Elements
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// helper
import {getToday, get_request_option} from '../Helper/helper'
import {Mode, CountryCodes} from '../Helper/constants';
import * as appointment_success from '../../testdata/appointment_success.json';
import PageHero from '../PageHero/PageHero';
// required for testing
// import * as appointment_500 from '../../testdata/appointment_500.json';
// import * as appointment_error from '../../testdata/appointment_error.json';

const TIME_SLOTS = [
    { code: 'M', label: 'Morning', range: 'Before 12 PM', icon: 'fa-sun', ends_at: 12 },
    { code: 'A', label: 'Afternoon', range: '12 PM – 6 PM', icon: 'fa-cloud-sun', ends_at: 18 },
    { code: 'E', label: 'Evening', range: 'After 6 PM', icon: 'fa-moon', ends_at: 22 },
];

// A slot can't be booked for today once its window is over.
const isSlotOver = (code, date) => {
    if(date !== new Date().toJSON().slice(0, 10)) {
        return false;
    }
    const slot = TIME_SLOTS.find(_slot => _slot.code === code);
    return slot ? new Date().getHours() >= slot.ends_at : false;
}

const formatDate = (iso) => {
    const [year, month, day] = (iso || '').split('-').map(Number);
    if(!year || !month || !day) {
        return iso;
    }
    return new Date(year, month - 1, day).toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
}

export default class AppointmentForm extends Component {

    componentDidMount() {
    // Update the browser's URL
    window.history.replaceState(null, '', '/appointment');
    }

    setField(name, value) {
        this.setState({
            appointment:{
                ...this.state.appointment,
                data: {
                    ...this.state.appointment.data,
                    [name]: value
                }
            }
        }, function() {
            if(this.state.appointment.errors[name]) {
                this.validate();
                this.forceUpdate();
            }
        }.bind(this));
    }

    handleChange = (e) => {
        const target = e.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        if(target.name === 'mobile') {
            value = value.replace(/\D/g, '');
        }
        this.setField(target.name, value);
    }

    showMessage(error_code) {
        let response = {};
        if(error_code === 500) {
            response = {
                'success': false,
                'heading': "Please try again.",
                'message': "Sorry! we failed to submit your appointment. Please try again.",
                'icon': "/img/fail.png",
            }
        } else if(error_code === 400) {
            response = {
                'success': false,
                'heading': "Appointment request was not sent !",
                'message': "Please select a different date as the clinic is closed on selected date.",
                'icon': "/img/fail.png",
            }
        } else {
            response = {
                'success': true,
                'heading': "Thanks for your time !",
                'message': "Your appointment has been submitted. You will be notified once the clinic confirms your appointment.",
                'icon': "/img/pass.png",
            }
            window.history.replaceState(null, '', "/appointment/submitted");
        }
        this.setState({
            response : response,
            step: 2
        })
    }

    handleAppointmentResponse(response) {
        if(response.status === 201) {
            this.showMessage(201);
        } else if(response.status === 500) {
            this.showMessage(500);
        } else if(response.status === 400) {
            this.showMessage(400);
        } else if(response.status === 403) {
            this.setState({
                appointment:{
                    ...this.state.appointment,
                    errors: response.errors
                }
            }, function() {
                this.setState({step:1});
                this.forceUpdate();
            }.bind(this))
        }
    }

    hasError() {
        for( const key in this.state.appointment.errors) {
            let value = this.state.appointment.errors[key];
            if(value.length > 0) {
                return true
            }
        }
        return false;
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.validate();
        this.forceUpdate();
        if(!this.hasError()) {
            this.setState({step:0});
            if(Mode.DEBUG) {
                let response = appointment_success.default;
                this.handleAppointmentResponse(response);
            } else {
                let appointmentJson = JSON.stringify(this.state.appointment.data);
                fetch(this.state.appointmentPostUrl, get_request_option("POST", appointmentJson))
                .then(response => response.json())
                .then(data => {
                    this.handleAppointmentResponse(data);
                }).catch( err => {
                    this.showMessage(500);
                });
            }
        }
    }

    validate = () => {
        this.state.appointment.errors.name = (this.state.appointment.data.name.length === 0) ? 'Please enter your name' : '';
        this.state.appointment.errors.mobile = (this.state.appointment.data.mobile.length < 8) ? 'Please enter your valid contact number' : '';
        this.state.appointment.errors.date = (this.state.appointment.data.date.length === 0) ? 'Please enter select a valid date' : '';
        this.state.appointment.errors.time_option = (this.state.appointment.data.time_option.length === 0) ? 'Please enter select a valid suitable time' : '';
        this.state.appointment.errors.consent = (this.state.appointment.data.consent.length === 0 || this.state.appointment.data.consent === false) ? 'Please provide your consent' : '';
        if(isSlotOver(this.state.appointment.data.time_option, this.state.appointment.data.date)) {
            this.state.appointment.errors.time_option = "Please select different time option.";
        }
    }

    state = {
        appointment: {
            data : {
                name: '',
                mobile: '',
                date: '',
                time_option: '',
                consent: '',
                appointment_type: 'clinic'
            },
            errors: {}
        },
        appointmentPostUrl: '/api/appointment',
        step: 1,
        dateFocused: false
    };

    renderError(name) {
        const error = this.state.appointment.errors[name];
        if(!error) {
            return null;
        }
        return <p className='appt-error'><i className="fa-solid fa-circle-exclamation"></i>{error}</p>;
    }

    renderForm() {
        const clinic = this.props.clinic;
        const data = this.state.appointment.data;
        const errors = this.state.appointment.errors;
        const field_class = (name) => 'appt-field' + (errors[name] ? ' has-error' : '');
        return (
            <form onSubmit={this.handleSubmit} noValidate>
                {clinic.overrides && clinic.overrides.appointment_notice?
                <div className='ui-notice'>
                    <i className="fa-solid fa-circle-info"></i>
                    <span dangerouslySetInnerHTML={{__html:clinic.overrides.appointment_notice}}></span>
                </div>:null}
                {clinic.holiday.enabled?
                <div className='ui-notice'>
                    <i className="fa-solid fa-circle-info"></i>
                    <span>
                        <b>Notice:</b> We are closed
                        {clinic.holiday.start===clinic.holiday.end?
                        <> on {clinic.holiday.start}. </>:<> from {clinic.holiday.start} to {clinic.holiday.end}. </>}
                        Please avoid booking appointments. Thank you.
                    </span>
                </div>:null}

                {clinic.overrides && clinic.overrides.virtual_appointment?
                <div className="appt-group">
                    <span className="appt-label" id="appointment_type_label">Type of visit</span>
                    <div className="appt-segment" role="radiogroup" aria-labelledby="appointment_type_label">
                        {[
                            { value: 'clinic', label: 'Clinic visit', icon: 'fa-hospital' },
                            { value: 'virtual', label: 'Online consultation', icon: 'fa-video' },
                        ].map(option => (
                            <button type="button" key={option.value} role="radio" aria-checked={data.appointment_type === option.value}
                                className={'appt-segment__option' + (data.appointment_type === option.value ? ' is-active' : '')}
                                onClick={() => this.setField('appointment_type', option.value)}>
                                <i className={`fa-solid ${option.icon}`}></i>{option.label}
                            </button>
                        ))}
                    </div>
                </div>:null}

                <div className="appt-row">
                    <div className="appt-group">
                        <label className="appt-label" htmlFor="name">Full name</label>
                        <div className={field_class('name')}>
                            <i className="fa-regular fa-user appt-field__icon"></i>
                            <input id="name" name="name" type="text" placeholder="Your full name" className="appt-input" autoComplete="name"
                                value={data.name} onChange={this.handleChange}/>
                        </div>
                        {this.renderError('name')}
                    </div>
                    <div className="appt-group">
                        <label className="appt-label" htmlFor="mobile">Mobile number</label>
                        <div className={field_class('mobile') + ' appt-field--prefix'}>
                            <span className="appt-field__prefix">{CountryCodes.india}</span>
                            <input id="mobile" name="mobile" type="tel" inputMode="numeric" placeholder="10-digit mobile" className="appt-input" autoComplete="tel-national" maxLength={10}
                                value={data.mobile} onChange={this.handleChange}/>
                        </div>
                        {this.renderError('mobile')}
                    </div>
                </div>

                <div className="appt-group">
                    <label className="appt-label" htmlFor="date">Preferred date</label>
                    <div className={field_class('date') + ' date-input-wrapper'}>
                        <i className="fa-regular fa-calendar appt-field__icon"></i>
                        <input type="date" id="date" name="date" value={data.date} className="appt-input" onChange={this.handleChange} min={getToday()}
                            onFocus={() => this.setState({dateFocused: true})}
                            onBlur={() => this.setState({dateFocused: false})}
                            style={!data.date && !this.state.dateFocused ? {color: 'transparent'} : {}}/>
                        {!data.date && !this.state.dateFocused && <span className="date-placeholder">Select a date</span>}
                    </div>
                    {this.renderError('date')}
                </div>

                <div className="appt-group">
                    <span className="appt-label" id="time_option_label">Preferred time</span>
                    <div className={'appt-slots' + (errors.time_option ? ' has-error' : '')} role="radiogroup" aria-labelledby="time_option_label">
                        {TIME_SLOTS.map(slot => {
                            const over = isSlotOver(slot.code, data.date);
                            const selected = data.time_option === slot.code;
                            return (
                                <button type="button" key={slot.code} role="radio" aria-checked={selected} disabled={over}
                                    className={'appt-slot' + (selected ? ' is-selected' : '')}
                                    onClick={() => this.setField('time_option', slot.code)}>
                                    <span className="appt-slot__icon"><i className={`fa-solid ${slot.icon}`}></i></span>
                                    <span className="appt-slot__label">{slot.label}</span>
                                    <span className="appt-slot__range">{over ? 'Not available today' : slot.range}</span>
                                    <i className="fa-solid fa-circle-check appt-slot__check"></i>
                                </button>
                            );
                        })}
                    </div>
                    {this.renderError('time_option')}
                </div>

                <div className="appt-group">
                    <label className={'appt-consent' + (errors.consent ? ' has-error' : '')}>
                        <input type="checkbox" name="consent" checked={data.consent === true} onChange={this.handleChange}/>
                        <span className="appt-consent__box"><i className="fa-solid fa-check"></i></span>
                        <span className="appt-consent__text">I declare that the information provided is correct. I would like to receive communication about the offered services.</span>
                    </label>
                    {this.renderError('consent')}
                </div>

                <button type="submit" name="book" className="ui-btn ui-btn--primary appt-submit">
                    <span>Request Appointment</span>
                    <i className="fa-solid fa-arrow-right ui-btn__arrow"></i>
                </button>
                <p className="appt-privacy"><i className="fa-solid fa-lock"></i>Your details are only shared with {clinic.name}.</p>
            </form>
        );
    }

    renderLoading() {
        return (
            <div className="appt-status" role="status">
                <span className="appt-spinner"></span>
                <h2 className="appt-status__title">Sending your request…</h2>
                <p className="appt-status__text">This will only take a moment.</p>
            </div>
        );
    }

    renderResult() {
        const response = this.state.response;
        const data = this.state.appointment.data;
        const slot = TIME_SLOTS.find(_slot => _slot.code === data.time_option);
        const call_url = this.contactUrls().call_url;
        return (
            <div className={'appt-status' + (response.success ? ' is-success' : ' is-error')}>
                <span className="appt-status__badge">
                    <i className={response.success ? 'fa-solid fa-check' : 'fa-solid fa-exclamation'}></i>
                </span>
                <h2 className="appt-status__title">{response.heading}</h2>
                <p className="appt-status__text">{response.message}</p>
                {response.success ?
                <dl className="appt-summary">
                    <div><dt>Name</dt><dd>{data.name}</dd></div>
                    <div><dt>Date</dt><dd>{formatDate(data.date)}</dd></div>
                    {slot ? <div><dt>Time</dt><dd>{slot.label} · {slot.range}</dd></div> : null}
                    {data.appointment_type === 'virtual' ? <div><dt>Visit</dt><dd>Online consultation</dd></div> : null}
                </dl> : null}
                <div className="appt-status__actions">
                    {response.success ?
                    <Link to="/" className="ui-btn ui-btn--primary">
                        <i className="fa-solid fa-house"></i><span>Back to Home</span>
                    </Link> :
                    <button type="button" className="ui-btn ui-btn--primary" onClick={() => this.setState({step: 1})}>
                        <i className="fa-solid fa-rotate-right"></i><span>Try again</span>
                    </button>}
                    {response.success ?
                    (call_url ?
                    <a href={call_url} className="ui-btn ui-btn--ghost">
                        <i className="fa-solid fa-phone"></i><span>Call clinic</span>
                    </a> : null) :
                    <Link to="/" className="ui-btn ui-btn--ghost">
                        <i className="fa-solid fa-house"></i><span>Back to Home</span>
                    </Link>}
                </div>
            </div>
        );
    }

    contactUrls() {
        const mobiles = this.props.clinic.contact.mobile;
        if(mobiles.length === 0) {
            return {};
        }
        return {
            call_url: "tel:" + CountryCodes.india + mobiles[0],
            whatsapp_url: "https://wa.me/" + CountryCodes.india.replace('+', '') + mobiles[0],
        };
    }

    renderPanel() {
        const clinic = this.props.clinic;
        const { call_url, whatsapp_url } = this.contactUrls();
        const is_virtual = this.state.appointment.data.appointment_type === 'virtual';
        const steps = [
            { title: 'Send your request', text: 'Takes less than a minute.' },
            { title: 'Clinic confirms', text: "You'll be notified once your slot is confirmed." },
            is_virtual ?
                { title: 'Join your consultation', text: 'Keep your phone handy at the chosen time.' } :
                { title: 'Visit the clinic', text: 'Arrive a few minutes early.' },
        ];
        return (
            <aside className="appt-panel">
                {call_url ?
                <div className="appt-panel__block">
                    <h3 className="appt-panel__title">Prefer to talk?</h3>
                    <div className="appt-panel__actions">
                        <a href={call_url} className="ui-btn ui-btn--ghost"><i className="fa-solid fa-phone"></i><span>Call</span></a>
                        <a href={whatsapp_url} target="_blank" rel="noopener noreferrer" className="ui-btn ui-btn--ghost appt-whatsapp"><i className="fa-brands fa-whatsapp"></i><span>WhatsApp</span></a>
                    </div>
                </div> : null}

                <div className="appt-panel__block">
                    <h3 className="appt-panel__title">Clinic details</h3>
                    {clinic.contact.address ?
                    <div className="appt-info">
                        <span className="appt-info__icon"><i className="fa-solid fa-location-dot"></i></span>
                        <div>
                            {clinic.contact.address2 ?
                            <>
                                <p><span className="appt-info__label">Main Branch</span>{clinic.contact.address}</p>
                                <p><span className="appt-info__label">Second Branch</span>{clinic.contact.address2}</p>
                            </> :
                            <p>{clinic.contact.address}</p>}
                        </div>
                    </div> : null}
                    {clinic.timing && clinic.timing.length > 0 ?
                    <div className="appt-info">
                        <span className="appt-info__icon"><i className="fa-regular fa-clock"></i></span>
                        <dl className="appt-hours">
                            {clinic.timing.map(_time => (
                                <div key={_time.days}><dt>{_time.days}</dt><dd>{_time.value}</dd></div>
                            ))}
                        </dl>
                    </div> : null}
                </div>

                <div className="appt-panel__block">
                    <h3 className="appt-panel__title">What happens next</h3>
                    <ol className="appt-steps">
                        {steps.map((step, index) => (
                            <li key={step.title}>
                                <span className="appt-steps__num">{index + 1}</span>
                                <div>
                                    <strong>{step.title}</strong>
                                    <span>{step.text}</span>
                                </div>
                            </li>
                        ))}
                    </ol>
                </div>
            </aside>
        );
    }

    render() {
        return (
            <div className="appt-page">
                <PageHero overlap eyebrow="Appointments" title="Book your visit"
                    text={`at ${this.props.clinic.name}. Pick a day and time that suits you; the clinic will confirm your appointment.`}/>
                <Container className="appt-body">
                    <Row>
                        <Col lg={7} md={12} sm={12} xs={12}>
                            <div className="appt-card">
                                {this.state.step === 1 ? this.renderForm() : null}
                                {this.state.step === 0 ? this.renderLoading() : null}
                                {this.state.step === 2 ? this.renderResult() : null}
                            </div>
                        </Col>
                        <Col lg={5} md={12} sm={12} xs={12}>
                            {this.renderPanel()}
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}
